import {Component} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../globals';
import {CommonModule} from '@angular/common';
import {FormService} from '../services/FormService';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-form-capture-location',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label>
        {{Yii.t('app', 'Capture Location')}}
      </label>
      <div>
        @if (!fsvc.form.isHTMLForm) {
          <p-checkbox
            [(ngModel)]="fsvc.form.captureLocation" binary="true"
            (change)="onCaptureLocationChange()"/>
        } @else {
          <div class="alert alert-info inline" style="margin: 0">
            Not available for HTML forms yet
          </div>
        }
      </div>
    </div>

    @if (!fsvc.form.isHTMLForm && fsvc.form.captureLocation) {
      <div class="form-row">
        <label>
          {{Yii.t('app', 'Show map in Front End')}}
        </label>
        <div>
          <p-checkbox [(ngModel)]="fsvc.form.showInFE" binary="true"/>
        </div>
      </div>
    }
  `
})
export class FormCaptureLocationComponent {
  Yii = Yii;

  constructor(public fsvc: FormService) {}

  onCaptureLocationChange(): void {
    this.fsvc.form.showInFE = false;
  }
}
